// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Navigate, useParams } from "react-router-dom";

import PropTypes from "prop-types";

export const RedirectById = ({ idParams = ["id"], path }) => {
  const params = useParams();
  let redirectPath = path;

  if (typeof path !== "string") {
    return null;
  }

  for (const idParam of idParams) {
    redirectPath = redirectPath.replace(`:${idParam}`, params[idParam]);
  }

  return <Navigate to={redirectPath} replace={true} />;
};

RedirectById.propTypes = {
  idParams: PropTypes.arrayOf(PropTypes.string),
  path: PropTypes.string.isRequired,
};
